module.exports = __webpack_public_path__ + "img/yuyue.842645af.png";